import { Address } from '@cp-mx/common';

export const addressValuesAreEmpty = (address: Address) =>
    !address?.city && !address?.countryCode && !address?.region && !address?.zipCode;
